import {Button, Card, Flex, Space} from "antd";
import Title from "antd/es/typography/Title";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faArrowUp, faTrash} from "@fortawesome/free-solid-svg-icons";
import {generateShotsPrompt} from "./prompts/PlotShotsPrompts";
import {PlotShotDetails} from "./PlotShotDetails";
import {aiChainPrompt, similaritySearch} from "../../../../../../ai/Prompt";
import {DraftScene} from "../../../../../../feature/Draft";
import {useAppDispatch, useAppSelector} from "../../../../../../feature/tools";
import {updateScene} from "../../../../../../feature/project/draftSlice";
import {TextAreaActions} from "../../../../../../ai/components/TextAreaActions";
import {GenButton} from "../../../../../../ai/components/GenButton";

export const PlotSceneDetails = (props: { scene: DraftScene }) => {
    const dispatch = useAppDispatch()
    const draft = useAppSelector(state => state.draftSlice.draft)

    const generateShots = async (model: string, projectId: string) => {
        let scenes = draft.story.acts.flatMap((act) => act.chapters.flatMap((chapter) => chapter.sections.flatMap(s => s.scenes)))
        let sceneIndex = scenes.findIndex((item) => item.id === props.scene.id)
        let prevScene = sceneIndex > 0 ? scenes[sceneIndex - 1] : undefined
        let nextScene = sceneIndex < scenes.length - 1 ? scenes[sceneIndex + 1] : undefined
        let context = await similaritySearch({
            project: projectId,
            query: props.scene.description ?? '',
            where: {"$or": [{'type': 'lore'}, {'type': 'setting'}, {'type': 'shot'}]}
        })
        let data = await aiChainPrompt({
            projectId: projectId,
            prompt: generateShotsPrompt({
                scene: props.scene,
                prevScene: prevScene,
                nextScene: nextScene,
                genres: draft.properties.genre,
                synopsis: draft.properties.synopsis,
                person: draft.properties.person,
                context: context?.documents
            }),
            model: model,
            type: 'json'
        })
        dispatch(updateScene({scene: {...props.scene, shots: data.data}}))
    }

    return (
        <Flex style={{padding: 4, flexGrow: 1, height: "100%", overflowY: 'auto', scrollbarWidth: "none"}}
              vertical={true} gap={10}>
            <Card title={props.scene.title}>
                <TextAreaActions
                    style={{border: "none"}}
                    value={props.scene.description}
                    autoSize={true}
                    validate={text => true}
                    onChange={(text: string) => {
                        dispatch(updateScene({
                            // @ts-ignore
                            scene: {
                                ...props.scene,
                                description: text
                            }
                        }))
                        return true
                    }}
                />
            </Card>
            <Card>
                <Flex justify={'space-between'} align={'center'} wrap={'wrap'}>
                    <Title level={5} style={{margin: 0}}>Shots</Title>
                    <Space>
                        <GenButton
                            style={{width: 130}}
                            type={'primary'}
                            actions={[{
                                key: "1", title: "Generate", action: async (model: string, projectId: string) =>
                                    generateShots(model, projectId)
                                        .catch((e) => {
                                            console.log(e)
                                        })
                            }]
                            }/>
                    </Space>
                </Flex>
            </Card>
            <Space direction={'vertical'}>
                {(props.scene.shots ?? []).map((item, index) =>
                    <Card style={{flexGrow: 1}} key={index}
                          title={<Flex justify={'space-between'}>
                              <Flex justify={'space-between'} gap={10} style={{flexGrow: 1, width: "100%"}}>
                                  <div style={{
                                      height: 30,
                                      width: 30,
                                      minWidth: 30,
                                      borderRadius: 30,
                                      background: "#ffffff",
                                      color: "#000",
                                      textAlign: "center",
                                      padding: 3
                                  }}>{index + 1}</div>
                                  <Space>
                                      <Button disabled={index == 0}
                                              type={'text'}
                                              style={{color: index == 0 ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,1)'}}
                                              icon={<FontAwesomeIcon icon={faArrowUp}/>}
                                              onClick={() => {
                                                  let shots = [...props.scene.shots]
                                                  let prev = {...shots[index - 1]}
                                                  let current = {...shots[index]}
                                                  let prevId = prev.id
                                                  prev.id = current.id
                                                  current.id = prevId

                                                  dispatch(updateScene({
                                                      // @ts-ignore
                                                      scene: {
                                                          ...props.scene,
                                                          shots: [...shots.filter((item) => item.id !== prev.id && item.id !== current.id)].concat([prev, current]).sort((a, b) => a.id - b.id) as []
                                                      }
                                                  }))
                                              }}/>
                                      <Button disabled={index == props.scene.shots.length - 1}
                                              style={{color: index == props.scene.shots.length - 1 ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,1)'}}

                                              type={'text'}

                                              icon={<FontAwesomeIcon icon={faArrowDown}/>} onClick={() => {
                                          let shots = [...props.scene.shots]
                                          let next = {...shots[index + 1]}
                                          let current = {...shots[index]}
                                          let nextId = next.id
                                          next.id = current.id
                                          current.id = nextId

                                          dispatch(updateScene({
                                              // @ts-ignore
                                              scene: {
                                                  ...props.scene,
                                                  shots: [...shots.filter((item) => item.id !== next.id && item.id !== current.id)].concat([current, next]).sort((a, b) => a.id - b.id) as []
                                              }
                                          }))
                                      }}/>
                                      <Button icon={<FontAwesomeIcon icon={faTrash}/>} onClick={() => {

                                          dispatch(updateScene({
                                              // @ts-ignore
                                              scene: {
                                                  ...props.scene,
                                                  shots: props.scene.shots.filter((it) => it.id !== item.id) as []
                                              }
                                          }))
                                      }}/>
                                  </Space>
                              </Flex>
                          </Flex>}>
                        <PlotShotDetails shot={item}/>
                    </Card>
                )}
            </Space>
        </Flex>
    )
}